import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const EntCtx = createContext(null);

const EMPTY = {
  loading: true,
  has_company: false,
  state: null,
  tier: null,
  days_left: null,
  grace_days_left: 0,
  features: [],
  limits: {},
  is_trial: false,
  read_only: false,
  platform_role: false,
};

export function EntitlementsProvider({ children }) {
  const [ent, setEnt] = useState(EMPTY);
  const auth = useAuth();
  // La sesión manda: cada login, logout, cambio de sucursal o de empresa cambia los permisos
  const sessionKey = auth?.user ? `${auth.user.user_id}:${auth.user.company_id}:${auth.user.store_id}` : "";
  const authLoading = !!auth?.loading;

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("aipos_token") && !localStorage.getItem("aipos_refresh") && !document.cookie.includes("session_token")) {
      setEnt({ ...EMPTY, loading: false });
      return;
    }
    try {
      const r = await api.get("/entitlements/me");
      setEnt({ ...EMPTY, ...r.data, loading: false });
    } catch {
      // Sin respuesta no bloqueamos nada: mejor dejar el menú abierto que mostrar candados falsos
      setEnt({ ...EMPTY, loading: true });
    }
  }, []);

  useEffect(() => {
    if (authLoading) return;
    if (!sessionKey) {
      setEnt({ ...EMPTY, loading: false });
      return;
    }
    refresh();
  }, [sessionKey, authLoading, refresh]);

  const has = useCallback(
    (code) => ent.platform_role || (ent.features || []).includes(code),
    [ent.platform_role, ent.features]
  );

  return <EntCtx.Provider value={{ ...ent, has, refresh }}>{children}</EntCtx.Provider>;
}

export function useEntitlements() {
  return useContext(EntCtx) || { ...EMPTY, loading: false, has: () => true, refresh: () => {} };
}

export const STATE_LABEL = {
  TRIAL_ACTIVE: "Prueba gratuita",
  TRIAL_WARNING: "Prueba por vencer",
  TRIAL_EXPIRED: "Prueba vencida",
  ACTIVE: "Plan activo",
  GRACE_PERIOD: "Periodo de gracia",
  PAYMENT_OVERDUE: "Pago pendiente · ventas bloqueadas",
  CANCELLED: "Cuenta dada de baja",
};

export const STATE_CLASS = {
  TRIAL_ACTIVE: "bg-sky-50 text-sky-700 border-sky-200",
  TRIAL_WARNING: "bg-amber-50 text-amber-800 border-amber-200",
  TRIAL_EXPIRED: "bg-rose-50 text-rose-700 border-rose-200",
  ACTIVE: "bg-emerald-50 text-emerald-700 border-emerald-200",
  GRACE_PERIOD: "bg-orange-50 text-orange-700 border-orange-200",
  PAYMENT_OVERDUE: "bg-rose-50 text-rose-700 border-rose-200",
  CANCELLED: "bg-slate-100 text-slate-600 border-slate-200",
};
